{
	"dialog": {
		"yes": "Ja",
		"no": "Nei"
	},
	"common": {
		"username": "Brukernavn",
		"first-name": "Fornavn",
		"last-name": "Etternavn",
		"optional": "valgfri",
		"cancel": "Avbryt",
		"back": "Tilbake",
		"skip": "Hopp over",
		"save": "Lagre",
		"search": "Søk"
	},
	"contacts-select": {
		"input-search-label": "Finn kontakter",
		"list-title": "Alle kontakter"
	},
	"stepper": {
		"steps-of-total": "{{completed}} av {{total}}"
	},
	"profile-photo-picker": {
		"change-photo": "Endre bildet",
		"replace-photo": "Bytt ut bildet",
		"upload-photo": "Last opp bilde"
	},
	"editable-items": {
		"add-information": "Legg til informasjon"
	},
	"edit-profile-form": {
		"critical": "Viktig",
		"positive": "Preferanser",
		"negative": "Utfordringer",
		"tooltip": {
			"critical": "Viktig informasjon for å sikre trygg og riktig omsorg",
			"positive": "Omsorgsmottakerens preferanser og interesser for å gi personlig omsorg",
			"negative": "Ting å være oppmerksom på for å unngå ubehag"
		},
		"email": "Email",
		"about-me": "Om meg",
		"restricted-access": "Begrenset tilgang"
	},
	"crop-photo-modal": {
		"move-and-scale-the-photo": "Flytt og skaler for å velge området av bildet som skal brukes.",
		"title": "Juster bildeområdet"
	},
	"table": {
		"no-data": "Ingen data"
	},
	"error-boundary": {
		"whoops-something-went-wrong": "Oops, noe gikk galt.",
		"please-either-refresh-the-page-or-try-again-later": "Vennligst oppdater siden eller prøv igjen senere.",
		"refresh": "Oppdater?"
	},
	"autocomplete-input": {
		"placeholder": "Skriv for å søke",
		"add-value": "Legg til \"{{value}}\""
	},
	"tags-editor": {
		"label": "Tagger",
		"placeholder": "Skriv for å søke etter tagger",
		"add-tag": "Legg til tag \"{{value}}\""
	},
	"form-period-control": {
		"period": {
			"day_one": "{{count}} dag",
			"day_other": "{{count}} dager",
			"custom": "Tilpasset"
		}
	}
}
